
const ROUTES = {
  DASHBOARD: '/dashboard',
  HOME: '/',
  APPOINTMENTS: '/appointments',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  MENU: '/menu',
  NOTIFICATIONS: '/notifications',
  ADS: '/ads',
  FINANCE: '/finance',
  STATISTICS: '/statistics',
  REVIEWS: '/reviews',
  STORIES: '/stories',
  INDEX: '/',
  
  DOCTOR: {
    ROOT: '/',
    DASHBOARD: '/dashboard',
    PROFILE: '/profile',
    SETTINGS: '/settings',
    PATIENTS: '/patients',
    CASE_FILE: {
      ROOT: '/case-file',
      DETAIL: (id: string | number) => `/case-file/${id}`,
      OVERVIEW: '/case-file/overview'
    },
    ADS: '/ads',
    ADVERTISEMENTS: '/advertisements',
    STATISTICS: '/statistics',
    TREATMENT_PLANS: '/treatment-plans',
    TREATMENT_PLANS_DETAIL: (id: string | number) => `/treatment-plans/${id}`,
    MESSAGES: {
      ROOT: '/messages',
      DETAIL: (id: string | number) => `/messages/${id}`
    },
    PATIENT_CHAT: {
      ROOT: '/messages',
      DETAIL: (id: string | number) => `/messages/${id}`
    },
    TREATMENT_SESSIONS: '/treatment-sessions',
    TREATMENT_SESSIONS_DETAIL: (id: string | number) => `/treatment-sessions/${id}`,
    PATIENT_SESSIONS: (id: string | number) => `/patient-sessions/${id}`,
    FOLLOW_UP_REPORTS: '/follow-up-reports',
    FOLLOW_UP_REPORTS_DETAIL: (id: string | number) => `/follow-up-reports/${id}`,
    POST_TREATMENT: {
      ROOT: '/post-treatment',
      DETAIL: (id: string | number) => `/post-treatment/${id}`
    },
    POST_TREATMENT_REPORTS: '/post-treatment',
    POST_TREATMENT_REPORT_DETAIL: (id: string | number) => `/post-treatment/${id}`,
    MEDICAL_DOCUMENTS: '/medical-documents',
    MEDICAL_DOCUMENTS_DETAIL: (id: string | number) => `/medical-documents/${id}`,
    BEFORE_AFTER: '/before-after',
    STORIES: '/stories',
    REVIEWS: '/reviews',
    AVAILABILITY: '/availability',
    APPOINTMENTS: '/appointments',
    CALENDAR: '/calendar',
    SERVICES: '/services',
    MY_INCOME: '/income',
    FINANCE: '/finance',
    NOTIFICATIONS: '/notifications',
    DOCUMENTS: '/documents',
    FAQ_SUPPORT: '/faq-support',
    AI_ASSISTANT: '/ai-assistant',
    CONTACT_SUPPORT: '/contact-support',
    PRIVACY_POLICY: '/privacy-policy',
    LEGAL_TERMS: '/legal-terms'
  },
  
  PATIENT: {
    ROOT: '/patient-area',
    HOME: '/patient-area/home',
    DASHBOARD: '/patient-area/dashboard',
    DOCTORS: '/patient-area/doctors',
    MESSAGES: {
      ROOT: '/patient-area/messages',
      DETAIL: (id: string | number) => `/patient-area/messages/${id}`
    },
    APPOINTMENTS: '/patient-area/appointments',
    DOCTOR_PROFILE: (id: string | number) => `/patient-area/doctor/${id}`,
    CLINIC_PROFILE: (id: string | number) => `/patient-area/clinic-profile/${id}`,
    NOTIFICATIONS: '/patient-area/notifications',
    PROFILE: '/patient-area/profile',
    SETTINGS: '/patient-area/settings',
    MEDICAL_SUBMISSION: '/patient-area/medical-submission',
    VOICE_CONSULTATION: (id: string | number) => `/patient-area/voice-consultation/${id}`,
    VIDEO_CONSULTATION: (id: string | number) => `/patient-area/video-consultation/${id}`,
    CLINICS: '/patient-area/clinics',
    MY_HEALTH: {
      ROOT: '/patient-area/my-health',
      APPOINTMENTS: '/patient-area/my-health/appointments',
      MEDICAL_RECORDS: '/patient-area/my-health/medical-records',
      TREATMENTS: '/patient-area/my-health/treatments',
      TREATMENT_PLANS: '/patient-area/my-health/treatment-plans',
      SUBMITTED_CASES: '/patient-area/my-health/submitted-cases',
      MEDICAL_DOCUMENTS: '/patient-area/my-health/medical-documents',
      PURCHASED_SERVICES: '/patient-area/my-health/purchased-services',
      INSURANCE: '/patient-area/my-health/insurance',
      FOLLOW_UP_CARE: '/patient-area/my-health/followup',
      FAVORITES: '/patient-area/my-health/favorites'
    },
    ITINERARY: '/patient-area/itinerary',
    LEGAL: {
      ROOT: '/patient-area/legal',
      TERMS: '/patient-area/legal/terms',
      PRIVACY: '/patient-area/legal/privacy',
      COOKIES: '/patient-area/legal/cookies',
      PATIENT_RIGHTS: '/patient-area/legal/patient-rights',
      DOCTOR_RESPONSIBILITIES: '/patient-area/legal/doctor-responsibilities',
      COMPENSATION: '/patient-area/legal/compensation',
      DISCLAIMERS: '/patient-area/legal/disclaimers',
      GDPR: '/patient-area/legal/gdpr',
      PRIVACY_POLICY: '/patient-area/legal/privacy-policy',
      HIPAA: '/patient-area/legal/hipaa',
      KVKK: '/patient-area/legal/kvkk',
      PATIENT_RESPONSIBILITIES: '/patient-area/legal/patient-responsibilities',
      TERMS_OF_USE: '/patient-area/legal/terms-of-use',
      DATA_USE_CONSENT: '/patient-area/legal/data-use-consent'
    }
  },
  
  MESSAGES: {
    ROOT: '/messages',
    DETAIL: (id: string | number) => `/messages/${id}`
  },

  ADMIN: {
    DASHBOARD: '/admin-area/dashboard',
    COUNTRIES_SETTINGS: '/admin-area/countries-settings',
    FINANCIALS: {
      ROOT: '/admin-area/financials',
      CLINICS: '/admin-area/financials/clinics'
    },
    INSIGHTS: '/admin-area/insights',
    SUB_ADMINS: '/admin-area/sub-admins',
    REPORTS_EXPORT: '/admin-area/reports-export',
    ADS_MONITORING: '/admin-area/ads-monitoring',
    CONTACT_SUPPORT: {
      ROOT: '/admin-area/contact-support'
    },
    SETTINGS: {
      ROOT: '/admin-area/settings',
      THEME: '/admin-area/settings/theme',
      API: '/admin-area/settings/api',
      NOTIFICATIONS: '/admin-area/settings/notifications',
      LOCATIONS: '/admin-area/settings/locations'
    },
    INSURANCE_PLANS: '/admin-area/insurance-plans',
    ROLES: '/admin-area/roles',
    PATIENTS: {
      ROOT: '/admin-area/patients'
    },
    CLINICS: {
      ROOT: '/admin-area/clinics'
    },
    DOCTORS: {
      ROOT: '/admin-area/doctors'
    }
  },

  CLINIC: {
    ROOT: '/clinic-area',
    DASHBOARD: '/clinic-area/dashboard',
    PROFILE: '/clinic-area/profile',
    NOTIFICATIONS: '/clinic-area/notifications',
    DOCTORS: '/clinic-area/doctors',
    SERVICES: '/clinic-area/services',
    ANALYTICS: '/clinic-area/analytics',
    ADS: '/clinic-area/ads',
    ADS_ANALYTICS: '/clinic-area/ads-analytics',
    ADS_CREATE: '/clinic-area/ads/create',
    SETTINGS: '/clinic-area/settings',
    FINANCIAL: '/clinic-area/financial',
    PERFORMANCE: '/clinic-area/performance',
    ACCOUNT_SETTINGS: '/clinic-area/account-settings',
    PROFILE_SETTINGS: '/clinic-area/profile-settings'
  }
};

export default ROUTES;
